import {IconCircle} from "@src/Shared/Components/ActionButton";
import AddIcon from "@material-ui/icons/Add";
import {Values} from "Tools/Values";
import React from "react";
import {AddActionButton} from "./styles";

interface IAddButtonProps {
    text: string;
    onClick: (e?: any) => void;
    margin?: number;
}

export const AddButton = ({text, onClick, margin}: IAddButtonProps) => (
    <div style={{margin: `${!margin ? 0 : margin}px`}}>
        <AddActionButton
            onClick={() => onClick()}
        >
            <IconCircle color={"maranics"}>
                <AddIcon/>
            </IconCircle>
            <span>{text}</span>
        </AddActionButton>
    </div>
)